<sb-searchable-list-section
	[hideFilter]="hideFilter()"
	[persuadeCards]="packageEventItems()"
	[title]="title()"
	[useStoryblokCards]="false"
/>
